<template>
  <div>
    <div class="hss1" id="qqq">
      <div class="w">
        <div class="box">
          <input
            class="ipt1"
            style="margin-bottom:.2rem"
            placeholder="请输入您的姓名"
            type="text"
            v-model="name"
          />
          <input
            class="ipt2"
            placeholder="请输入您的手机号"
            v-model="phone"
            type="number"
          />
          <button class="btn" @click="_submitForm()">0元领取指标</button>
        </div>
      </div>
    </div>
    <div class="hs1">
      <img
        src="../../../assets/img/pagess/mobile/gdd102/抖音广告_02.gif"
        alt=""
      />
    </div>
    <div class="hs1">
      <img
        src="../../../assets/img/pagess/mobile/gdd102/抖音广告_03.jpg"
        alt=""
      />
    </div>
    <div class="hs1">
      <img
        src="../../../assets/img/pagess/mobile/gdd102/抖音广告_04.jpg"
        alt=""
      />
    </div>
    <div class="hs1">
      <img
        src="../../../assets/img/pagess/mobile/gdd102/抖音广告_05.jpg"
        alt=""
      />
    </div>
    <div class="hs1">
      <a href="#qqq">
        <img
          src="../../../assets/img/pagess/mobile/gdd102/抖音广告_06.jpg"
          alt=""
        />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      phone: ""
    };
  },
  mounted() {
    this.clientIp();
  },
  methods: {
    clientIp() {
      this.$http
        .post("/client_ip", { url: window.location.href })
        .then(res => {});
    },

    // 提交数据
    _submitForm() {
      this.content = [this.company, this.sheng, this.shi, this.qu];
      if (!this.name) {
        alert("姓名不能为空");
        return;
      }
      if (this.name.length < 2) {
        alert("为确保方案准确性，请输入正确的姓名");
        return;
      }
      if (!this.phone) {
        alert("手机号不能为空");
        return;
      }
      this.$http
        .post(
          "/creates-info",
          // 请求参数
          {
            name: this.name,
            type: "juniu_office",
            phone: this.phone
          }
        )
        .then(res => {
          alert(res.data);
          this.name = "";
          this.phone = "";
          // this.copies=66;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.tan {
  position: fixed;
  top: 2rem;
  left: 1.25rem;
  width: 5rem;
  height: 3.5rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .aa {
    width: 0.1rem;
    margin: 0 auto;
    position: absolute;
    .close {
      position: relative;
      width: 0.4rem;
      height: 0.4rem;
      left: 2.1rem;
      top: 0.1rem;
    }
  }
  .li-1 {
    padding-top: 0.2rem;
    display: flex;
    align-items: center;

    span {
      font-size: 0.16rem;
    }
  }
  .li-2 {
    margin-top: 0.2rem;
    font-size: 0.16rem;
  }
}

img {
  width: 100%;
  height: 100%;
  display: block;
}
.hss1 {
  width: 7.5rem;
  height: 11.42rem;
  background: url(../../../assets/img/pagess/mobile/gdd102/抖音广告_01.jpg);
  background-size: 100% 100%;
  .w {
    width: 5rem;
    margin: 0 auto;
    padding-top: 9rem;

    .box {
      width: 5rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      input {
        width: 100%;
        height: 0.6rem;
        border: none;
        border-radius: 0.1rem;
        border: 0.02rem solid #ccc;
        outline: none;
      }
      button {
        margin-top: 0.2rem;
        width: 100%;
        height: 0.8rem;
        border-radius: 0.2rem;
        border: none;
        font-size: 0.36rem;
        color: #fff;
        background-color: #fb0000;
      }
    }
  }
}
.h3 {
  width: 7.5rem;
  height: 4.68rem;
  position: relative;
  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    top: 0;
    left: 0.8rem;
  }
}
.h5 {
  width: 7.5rem;
  height: 4.68rem;
  position: relative;
  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    top: 0.9rem;
    left: 0.8rem;
  }
}
.h7 {
  width: 7.5rem;
  height: 4.68rem;
  position: relative;
  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    top: 1.3rem;
    left: 0.8rem;
  }
}
.h9 {
  width: 7.5rem;
  height: 4.68rem;
  position: relative;
  .btn {
    width: 5.92rem;
    height: 1.22rem;
    position: absolute;
    bottom: 1rem;
    left: 0.8rem;
  }
}
.h11 {
  position: fixed;
  bottom: 0;
  width: 7.5rem;
  height: 1.62rem;
  background: url(../../../assets/img/pagess/mobile/sky101/heng.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-end;
  .img2 {
    padding-top: 0.19rem;
    padding-right: 0.12rem;
    width: 2.61rem;
    height: 0.78rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pagess/mobile/gdd102.vue